/** The cabinet UI is Russian-only. */
export const FALLBACK_LANGUAGE = "ru";
